<mat-toolbar
  [style]="!environment.production ? 'background-color: crimson !important' : ''"
  color="primary"
  class="app-toolbar"
>
  @if ((isHandset$ | async) && (isAdminRoute$ | async)) {
    <button mat-icon-button (click)="toggleAdminSidenav()" aria-label="Admin-Menü umschalten">
      <mat-icon>menu</mat-icon>
    </button>
  }

  <a routerLink="/" class="brand" aria-label="Zur Startseite" title="Zur Startseite">
    <img src="assets/favicon.ico" alt="Logo" class="brand-logo" />
    <h1 class="app-title"> Rast-WC.de </h1>
  </a>

  <span class="spacer"></span>

  <button mat-icon-button [matMenuTriggerFor]="themeMenu" aria-label="Theme wechseln" [hidden]="true">
    <mat-icon>palette</mat-icon>
  </button>
  @if (!(isHandset$ | async)) {
    <a href="/search">
      <button mat-icon-button [routerLink]="'search'" class="user-menu-button">
        <mat-icon style="top: 4px">search</mat-icon>
      </button>
    </a>
  }

  @if ((authService.currentUser$ | async) && !(isHandset$ | async)) {
    <button mat-icon-button [routerLink]="'favorites'" class="user-menu-button">
      <mat-icon style="top: 2px">star</mat-icon>
    </button>
  }

  @if ((authService.currentUser$ | async) && authService.isAdmin()) {
    <button mat-icon-button [routerLink]="'admin'" class="user-menu-button">
      <mat-icon style="top: 2px">admin_panel_settings</mat-icon>
    </button>
  }
  @if (authService.currentUser$ | async; as user) {
    <app-notification-bell></app-notification-bell>
    <div style="width: 1rem"></div>
    <span
      class="update-avatar-badge"
      matBadge="!"
      matBadgeColor="warn"
      matBadgeSize="small"
      [matBadgeHidden]="!updateService.updateAvailable()"
    >
      <button mat-icon-button [matMenuTriggerFor]="userMenu" class="user-menu-button" aria-label="Benutzermenü">
        @if (user.profilePictureUrl) {
          <img [src]="environment.backend + user.profilePictureUrl" class="user-avatar" alt="Profilbild" />
        } @else {
          <mat-icon style="top: 2px">account_circle</mat-icon>
        }
      </button>
    </span>
    <mat-menu #userMenu="matMenu">
      <button mat-menu-item (click)="goToProfile(user)">
        <mat-icon>person</mat-icon>
        <span>Mein Profil</span>
      </button>
      <button mat-menu-item [routerLink]="'settings'">
        <mat-icon>settings</mat-icon>
        <span>Einstellungen</span>
      </button>
      <button mat-menu-item (click)="openInfoDialog()">
        <mat-icon
          matBadge="!"
          matBadgeColor="warn"
          matBadgeSize="small"
          [matBadgeHidden]="!updateService.updateAvailable()"
        >info</mat-icon>
        <span>Info</span>
      </button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        <span>Logout</span>
      </button>
    </mat-menu>
  } @else {
    @if (isHandset$ | async) {
      <a mat-icon-button routerLink="/login" aria-label="Anmelden">
        <mat-icon>login</mat-icon>
      </a>
    } @else {
      <a mat-button routerLink="/login">Anmelden</a>
      <a mat-stroked-button routerLink="/register">Registrieren</a>
    }
  }
  <mat-progress-bar
    *ngIf="isLoading$ | async"
    mode="indeterminate"
    [color]="!environment.production ? 'warn' : 'accent'"
    class="toolbar-progress"
  ></mat-progress-bar>
</mat-toolbar>

<mat-menu #themeMenu="matMenu">
  <button
    mat-menu-item
    (click)="setTheme('magenta')"
    role="menuitemradio"
    [attr.aria-checked]="activeTheme === 'magenta'"
  >
    <mat-icon>palette</mat-icon>
    <span>Magenta</span>
    <span class="spacer"></span>
    <mat-icon *ngIf="activeTheme === 'magenta'">check</mat-icon>
  </button>
  <button
    mat-menu-item
    (click)="setTheme('green-dark')"
    role="menuitemradio"
    [attr.aria-checked]="activeTheme === 'green-dark'"
  >
    <mat-icon>palette</mat-icon>
    <span>Dunkelgrün</span>
    <span class="spacer"></span>
    <mat-icon *ngIf="activeTheme === 'green-dark'">check</mat-icon>
  </button>
  <button
    mat-menu-item
    (click)="setTheme('blue-dark')"
    role="menuitemradio"
    [attr.aria-checked]="activeTheme === 'blue-dark'"
  >
    <mat-icon>palette</mat-icon>
    <span>Dunkelblau</span>
    <span class="spacer"></span>
    <mat-icon *ngIf="activeTheme === 'blue-dark'">check</mat-icon>
  </button>
</mat-menu>
